import programDataRootReducer from './programData'
import wpServerDataReducer from './wpServerData'
import wpLocalDataReducer from './wpLocalData'
import uiReducer from './ui'
import printReducer from './printData'
import pushReducer from './pushData'
import cliDataReducer from './cliData/reducer'
import newsletterServerDataReducer from './newsletterServerData'
import newsletterLocalDataReducer from './newsletterLocalData'
import multisiteSelectorReducer from './multisiteSelectorData'
import routesDataReducer from './routesData'
import actionTypes from '../actions/actionTypes'
import { Map } from 'immutable'
import {  AUTH, CLI, EVENT_DATA, LOAD_ALL, MULTISITE_SELECTOR, NEWSLETTERLOCAL, NEWSLETTERSERVER, PRINTDATA, PROGRAM, PUSHDATA, ROUTER, ROUTES_DATA, SIGNAGE_DATA, TRANSLATION, UI, WPLOCAL, WPSERVER } from '../constants/state'
import authReducer from './auth'
import loadAllReducer from './loadAll'
import { combineReducers } from 'redux-immutable'
import translationDataReducer from './translationData'
import { connectRouter } from 'connected-react-router/immutable'
import eventDataReducer from './eventData'
import signageReducer from './signageData'


const INIT_STATE = Map({})

const createCombineReducers = history => combineReducers({
    [ROUTER]: connectRouter(history),
    [TRANSLATION]: translationDataReducer,
    [AUTH]: authReducer,
    [LOAD_ALL]: loadAllReducer,
    [PROGRAM]: programDataRootReducer,
    [WPSERVER]: wpServerDataReducer,
    [WPLOCAL]: wpLocalDataReducer, 
    [NEWSLETTERSERVER]: newsletterServerDataReducer,
    [NEWSLETTERLOCAL]: newsletterLocalDataReducer, // ToDo: Testen1!111
    [UI]: uiReducer,
    [PRINTDATA]: printReducer,
    [PUSHDATA]: pushReducer,
    [SIGNAGE_DATA]: signageReducer,
    [CLI]: cliDataReducer,
    [MULTISITE_SELECTOR]: multisiteSelectorReducer,
    [ROUTES_DATA]: routesDataReducer,
    [EVENT_DATA]: eventDataReducer,
})


const createRootReducer = history => {
    const combReducer = createCombineReducers(history)

    return (state = INIT_STATE, action) => {
        if(actionTypes.CLEAR_ALL_DATA === action.type) {
            state = new Map({
                [ROUTER]: state.get(ROUTER),
                [TRANSLATION]: state.get(TRANSLATION)
            })
        }

        return combReducer(state, action)
    }
}

export default createRootReducer